'use client';

import type { MediaCard } from 'src/sections/search-all/utils/search-all-media-cards';

import { useMemo } from 'react';

import { useSearchAllVideoUrls } from 'src/sections/search-all/hooks/load/fetch/use-search-all-video-urls';
import { useSearchAllMediaDetail } from 'src/sections/search-all/hooks/handler/use-search-all-media-detail';

/**
 * 목록 하나에 **소재 상세 한 벌** — 어느 보기에서 눌러도 같은 상세를 열고, 이전/다음은 `cards` 순서를 따른다.
 *
 * 🔑 영상 주소는 목록과 상세가 **한 벌을 같이 쓴다** — 격자가 받아 둔 주소로 상세가 바로 틀고,
 *   격자에 없던 카드(카드·리스트·테이블에서 연 것)는 열 때 주소를 묻는다.
 * @param cards 화면이 지금 편 순서 그대로의 카드
 * @returns `open`(카드를 연다) · `videoUrls`(격자 칸에도 넘긴다) · `detail`(`HubMediaDetail` 에 그대로 펼친다)
 */
export function useListMediaDetail(cards: MediaCard[]) {
  const videoUrls = useSearchAllVideoUrls();
  const detail = useSearchAllMediaDetail(cards, videoUrls.need);
  const nav = useMemo(
    () => ({ hasPrev: detail.hasPrev, hasNext: detail.hasNext, onPrev: detail.prev, onNext: detail.next }),
    [detail.hasPrev, detail.hasNext, detail.prev, detail.next],
  );
  return {
    open: detail.open,
    videoUrls,
    detail: { card: detail.card, onClose: detail.close, nav, videoUrls },
  };
}
